import * as types from './types'
import storage from '@/Plugins/storage'

export default {
  [types.SET_RECIPIENTS](state, data) {
    state.recipients = []
    if (data !== undefined && data !== null) {
      state.recipients = JSON.parse(JSON.stringify(data.recipients))
    }
    console.log('Just Set Recipients', state.recipients)
  },
  [types.RESET_CANNEDMESSAGE](state, data) {
    state.cannedmessage = JSON.parse(JSON.stringify(state.defaultCannedMessage))
    state.cannedmessage.user_id = data.userid
    state.cannedmessage.organization_id = data.orgid
  },
  [types.SET_CANNEDMESSAGES](state, data) {
    state.cannedmessages = []
    if (data !== undefined && data !== null) {
      state.cannedmessages = data
    }
  },
  [types.SET_CANNEDMESSAGE](state, data) {
    state.cannedmessage = null
    if (data !== undefined && data !== null) {
      state.cannedmessage = data
    }
    console.log('Got Canned Message', state.cannedmessage)
  },
  [types.SET_CANNEDMESSAGE_DATA](state, data) {
    switch (data.name) {
      case 'userid': {
        state.cannedmessage.user_id = data.value
        break
      }
      case 'orgid': {
        state.cannedmessage.organization_id = data.value
        break
      }
      case 'subject': {
        state.cannedmessage.subject = data.value
        break
      }
      case 'body': {
        state.cannedmessage.body = data.value
        break
      }
      case 'type': {
        state.cannedmessage.type = data.value
        break
      }
      case 'isInactive': {
        state.cannedmessage.isInactive = data.value
        break
      }
      case 'isInvite': {
        state.cannedmessage.isInvite = data.value
        break
      }
    }
  },
}
